import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { Container, Col, Row } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { JsonToTable } from "react-json-to-table";
import xls from "xlsx";
import { getFundByAmc } from "../../stores/services/funds.service";
import Dropdown from "react-bootstrap/Dropdown";
import Select from "react-select";
import useCustomStyles from "../../hooks/useCustomStyles";
import { getAmc } from "../../stores/services/amc.service";

function PFFundUploader() {
    const email = sessionStorage.getItem("email") || "";
    const amcCode = sessionStorage.getItem('amc_code') || '';
    const [file, setFile] = useState("");
    const [fileName, setFileName] = useState("");
    const [fileError, setFileError] = useState("");
    const [fileData, setfileData] = useState<any>([]);
    const myRef1 = useRef<HTMLInputElement>(null);
    const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
    const [fileDataCount, setFileDataCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [fund, setFund] = useState("");
    const [fundLoading, setFundLoading] = useState<boolean>(false);
    const [allFunds, setAllFunds] = useState<any>([]);
    const [amcName, setAmcName] = useState("");
    const [amcdata, setAmcdata] = useState<any>([]);
    const { customStyles } = useCustomStyles();

    const getfundByAmcCode = async (code: string, fund_type?: string) => {
        allFunds.length = 0;
        setAllFunds(allFunds);
        //get funds by amc for dropdown
        try {
            const response = await getFundByAmc(
                email,
                code,
                fund_type ? { fund_type } : undefined
            );
            setAllFunds(response.data.data);
            if (response.data.data.length > 0) {
                setFundLoading(false);
            } else {
                setFundLoading(true);
            }
        } catch (err: any) {
            if (err.response !== undefined) {
                toast.error(err.response.data.message);
            } else {
                toast.error(err.message);
            }
        }
    };
    React.useEffect(() => {
        getfundByAmcCode(amcCode);
    }, [])

    const renderFundsDropdown = () => {
        let temp: any = []
        temp = allFunds.map((item: any, index: string) => {
            if (item.nature === "Special Managed Account") {
                return {
                    value: item.symbol_code,
                    label: `${item.fund_name} (${item.symbol_code}) - SMA`,
                };
            } else {
                return {
                    value: item.symbol_code,
                    label: `${item.fund_name} (${item.symbol_code})`,
                };
            }
        });
        return temp
    };

    const selectedFundName = React.useMemo(() => {
        const selectedFund = allFunds.find((item) => item?.symbol_code === fund);
        return selectedFund && selectedFund.nature === "Special Managed Account"
            ? {
                value: selectedFund.symbol_code,
                label: `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`,
            }
            : selectedFund
                ? {
                    value: selectedFund.symbol_code,
                    label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
                }
                : null;
    }, [allFunds, fund]);

    const upload = async (e: any) => {
        if (e?.target.files[0] && e.target.value) {
            setFileError("");
            setfileData(null);
            let file = e?.target.files[0];

            let type = file?.name?.substring(file?.name?.lastIndexOf(".") + 1);
            if (type === "xlsx" || type === "csv") {
                setFile(file);
                setFileName(file?.name);
                //start

                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
                reader.onload = (e) => {
                    const bstr = e.target?.result;
                    const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });

                    const sheetNames = wb.SheetNames;
                    const allSheetsData = {};
                    let data: any

                    sheetNames?.forEach(sheetName => {
                        const ws = wb.Sheets[sheetName];
                        const data1 = xls.utils.sheet_to_json(ws, {
                            header: 2,
                            raw: false,
                            defval: "",
                            dateNF: "YYYY-MM-DD",
                        });
                        allSheetsData[sheetName] = data1;
                        console.log("data11111", data1)
                        data = data1
                    });

                    const uploadedHeaders = Object.keys(data[0])?.filter((ele) => !ele?.includes("__EMPTY")).map(item => item.trim()?.toLowerCase()); // remvoving spaces for better matching

                    // if file is empty 
                    if (data?.length === 0 || data === undefined) {
                        toast.error("File Should not be empty")
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }
                    { console.log("data---", data) }

                    if (data?.some((ele) => ele["Fund Code"]?.trim() !== fund)) {
                        toast.error("Please upload a file with fund codes matching the selected fund.");
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }

                    // if (!uploadedHeaders?.includes("employee code") || data?.some((ele) => ele["Employee Code"]?.trim() == "")) {
                    //     const indexOfErr = data?.findIndex((item) => item["Employee Code"]?.trim() == "")
                    //     toast.error(`Employee Code should not be empty for row ${indexOfErr + 2}`)
                    //     setfileData([]);
                    //     setFileDataCount(0);
                    //     setFileName("")
                    //     return
                    // }

                    // if (!uploadedHeaders?.includes("employee name") || data?.some((ele) => ele["Employee Name"]?.trim() == "")) {
                    //     const indexOfErr = data?.findIndex((item) => item["Employee Name"]?.trim() == "")
                    //     toast.error(`Employee Name should not be empty for row ${indexOfErr + 2}`)
                    //     setfileData([]);
                    //     setFileDataCount(0);
                    //     setFileName("")
                    //     return
                    // }


                    if (data.length > 0) {
                        // filter those keys which has ___Empty 
                        const filteredData = data.map(obj => {
                            return Object.fromEntries(
                                Object.entries(obj).filter(([key]) => !key.startsWith('__EMPTY'))
                            );
                        });
                        setfileData(filteredData);
                        setFileDataCount(data.length);

                    }

                };
                if (rABS) reader.readAsBinaryString(file);
                else reader.readAsArrayBuffer(file);
            } else {
                toast.error("Please Upload Correct Format of File");
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
            }
            e.target.value = ""
        }

    };

    const handleUploadClick = () => {
        if (fileData && fileData.length > 0) {
            setLoading(true);

            try {
                // Get existing data from localStorage
                const existingData = JSON.parse(localStorage.getItem("pf_funds") || "[]");

                // Combine existing data with new data
                const combinedData = [...existingData, ...fileData];

                // Save combined data to localStorage
                localStorage.setItem("pf_funds", JSON.stringify(combinedData));

                toast.success(`Successfully uploaded ${fileData.length} records`);

                // Reset form
                setfileData([]);
                setFileDataCount(0);
                setFileName("");
                setFile("");
                setFund("")
                setAmcName("")
            } catch (error) {
                toast.error("Error saving data to local storage");
                console.error("LocalStorage error:", error);
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("Please select and process a file first");
        }
    };

    return (
        <div className="content">
            <Row>
                <Col md="12">
                    <Container fluid>
                        <ToastContainer limit={1} />
                        <div className="card">
                            <div className="d-flex align-items-center"></div>

                            <div className="">
                                <div className="card-header">
                                    <h4 className="card-title">
                                        Provident Fund Monthly Deposit Uploader
                                        <Dropdown className="float-right">
                                            <Dropdown.Toggle
                                                // href={`${env.REACT_APP_SAMPLE_URL}PF-SAMPLE.xlsx`} 
                                                variant="dark"
                                                id="dropdown-basic"
                                            >
                                                Download Sample
                                            </Dropdown.Toggle>
                                        </Dropdown>
                                    </h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-md-3">
                                            <label>
                                                Fund <span className="color-amber">*</span>
                                            </label>
                                            {fundLoading ? (
                                                <div className="form-control w-100">
                                                    <i className="fa fa-spinner fa-spin fa-1x"></i>
                                                </div>
                                            ) : (
                                                <Select
                                                    disabled={false}
                                                    value={selectedFundName}
                                                    label={fundLoading ? "Loading..." : "Select Fund"}
                                                    onChange={(e) => {
                                                        console.log("value----", e?.value)
                                                        setFund(e?.value);
                                                    }}
                                                    menuPortalTarget={document.body}
                                                    menuShouldBlockScroll={true}
                                                    isClearable={true}
                                                    isSearchable={true}
                                                    name="color"
                                                    options={renderFundsDropdown()}
                                                    styles={customStyles}
                                                />
                                            )}
                                        </div>
                                        <div className="col-md-4">
                                            <label>Choose File</label>

                                            <div onClick={() => {
                                                if (fund) {
                                                    myRef1?.current?.click()
                                                }
                                            }}>
                                                <div className="form-group">
                                                    <div
                                                        className="form-control"
                                                        data-tip="Upload Unit Holding File"
                                                    >
                                                        {fileName === "" ? "Upload File" : fileName}
                                                    </div>
                                                    <input
                                                        type="file"
                                                        ref={myRef1}
                                                        style={{ display: "none" }}
                                                        multiple={false}
                                                        data-tip="Upload File"
                                                        onChange={(e) => {
                                                            if (fund) {
                                                                upload(e);
                                                            }
                                                            else {
                                                                toast.error("Select fund first")
                                                            }
                                                        }}
                                                        onClick={(e) => {
                                                            e.currentTarget.value = "";
                                                        }}
                                                    />
                                                    {fileError ? (
                                                        <p className="error-labels error-message2">
                                                            {fileError}
                                                        </p>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                            {fileUploadingFlag && (
                                                <i className="fa fa-spinner fa-spin fa-2x"></i>
                                            )}
                                        </div>
                                    </div>
                                    {/* </div> */}
                                    {
                                        fileData?.length > 0 ? (
                                            <div className="table-responsive">
                                                <JsonToTable json={fileData} />
                                            </div>
                                        ) : (
                                            fileName ?
                                                <Row className="d-flex justify-content-center my-3">
                                                    <i
                                                        className="fa fa-spinner fa-spin fa-3x"
                                                        aria-hidden="true"
                                                    ></i>
                                                </Row> : null
                                        )
                                    }
                                    Total Rows:{" "}
                                    <span className="text-primary mt-3">{fileDataCount} </span>
                                    <div className="">
                                        <button
                                            className="btn btn-primary"
                                            onClick={() => {
                                                handleUploadClick()
                                            }}
                                            disabled={Boolean(loading) || fileData?.length == 0}
                                        >
                                            {loading ? (
                                                <>
                                                    <span
                                                        className="spinner-border login-txt spinner-border-sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    ></span>
                                                    <span className="login-txt"> Loading...</span>
                                                </>
                                            ) : (
                                                <span>Upload</span>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </Col>
            </Row>
        </div>
    )
}

export default PFFundUploader